import { render, staticRenderFns } from "./mergeaccounts.vue?vue&type=template&id=f09107e2&"
import script from "./mergeaccounts.vue?vue&type=script&lang=js&"
export * from "./mergeaccounts.vue?vue&type=script&lang=js&"
import style0 from "./mergeaccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports